// extracted by mini-css-extract-plugin
export default {"wrapper":"jy-z","viewport":"ky-z","container":"ly-z","slide":"my-z"};